import React, { useState, useEffect } from 'react';
import { DillButton, DillModal } from '../../../general/Dill';
import { AppInputField } from '../../../general/AppInputField/AppInputField';

const RejectMessageModal = ({
  open,
  handleClose,
  onSubmit,
}: {
  open: boolean;
  handleClose: () => void;
  onSubmit: (val: string) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    if (open) {
      setLoading(false);
      setText('');
    }
  }, [open]);

  const handleCloseModal = () => {
    setLoading(false);
    setText('');
    handleClose();
  };

  const handleSubmit = () => {
    onSubmit(text);
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title="Add Reject Reason"
      footer={
        <div className="flex justify-end w-full gap-2">
          <DillButton label="Close" variant="secondary" onClick={handleCloseModal} />
          <DillButton
            label="Submit"
            onClick={handleSubmit}
            isLoading={loading}
            isDisabled={loading}
          />
        </div>
      }>
      <AppInputField
        label="Reject reason"
        value={text}
        inputType="textarea"
        onTextChange={(val) => {
          setText(val);
        }}
      />
    </DillModal>
  );
};

export default RejectMessageModal;
